import { useState, useEffect } from 'react'
import { useMediaQuery } from '@mui/material'
import { BaseModal2 } from '@components/modals/BaseModal2'
import { Input } from '@components/shared/Input'
import { emotionTheme } from '@styles/theme'
import { MoneyIcon } from '@assets/svgs/MoneyIcon'
import { WarningIcon } from '@assets/svgs/WarningIcon'
import { PencilSimple } from '@phosphor-icons/react'
import { currencyMask } from '@utils/masks/currencyMask'
import { unMaskCurrency } from '@utils/masks/unMaskCurrency'

import type { EditSalaryItemModalProps } from './types'
import * as S from './styles'

export const EditSalaryItemModal = ({
  open,
  onClose,
  itemName,
  itemCode,
  currentValue,
  onConfirm,
  isLoading = false
}: EditSalaryItemModalProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)
  const [value, setValue] = useState('')

  useEffect(() => {
    if (open) {
      setValue(currencyMask(currentValue.toFixed(2)))
    } else {
      setValue('')
    }
  }, [open, currentValue])

  const handleConfirm = async () => {
    const numericValue = unMaskCurrency(value)
    if (numericValue >= 0) {
      await onConfirm(numericValue)
    }
  }

  return (
    <BaseModal2
      open={open}
      title=""
      headerIcon={
        <S.Header>
          <S.HeaderIcon>
            <MoneyIcon />
          </S.HeaderIcon>
          <S.HeaderTitle>Salários</S.HeaderTitle>
        </S.Header>
      }
      onClose={onClose}
      width={isMobile ? 'calc(100% - 20px)' : 500}
      heightContainer="auto"
      maxHeightContainer={isMobile ? 'calc(100% - 20px)' : '95%'}
      footer={{
        cancelButtonText: 'Voltar',
        cancelButtonMinWidth: isMobile ? 'calc(50% - 8px)' : 193.5,
        confirmButtonText: 'Confirmar',
        confirmButtonMinWidth: isMobile ? 'calc(50% - 8px)' : 193.5,
        onConfirm: handleConfirm,
        loading: isLoading,
        actionsAlign: 'center'
      }}
    >
      <S.Container>
        <S.SubHeader>
          <S.SubHeaderIcon>
            <PencilSimple size={18} weight="regular" />
          </S.SubHeaderIcon>
          <S.SubHeaderTitle>Editar {itemName}</S.SubHeaderTitle>
        </S.SubHeader>

        <S.AlertBanner>
          <WarningIcon />
          <S.AlertText>
            O valor inserido na edição, será contemplado na prévia até atualização automática pelo sistema.
          </S.AlertText>
        </S.AlertBanner>

        <S.FieldsRow>
          <S.ItemInfo>
            <S.ItemName>{itemName}</S.ItemName>
            <S.ItemCode>{itemCode}</S.ItemCode>
          </S.ItemInfo>

          <S.InputWrapper>
            <Input
              hasController={false}
              name="valor"
              label="Valor (R$)"
              placeholder="R$ 0,00"
              value={value}
              onChange={(e) => setValue(currencyMask(e.target.value))}
              maskType="currency"
            />
          </S.InputWrapper>
        </S.FieldsRow>
      </S.Container>
    </BaseModal2>
  )
}
